export default "__VITE_ASSET__DJq7zG2H__"